import { render, staticRenderFns } from "./EmployeeShow.vue?vue&type=template&id=1bbb358b&scoped=true&"
import script from "./EmployeeShow.vue?vue&type=script&lang=js&"
export * from "./EmployeeShow.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeShow.vue?vue&type=style&index=0&id=1bbb358b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbb358b",
  null
  
)

export default component.exports